import {
    GET_ITINERARY
} from '../actions/types';


export default function (state = null, action) {
    switch (action.type) {
        case GET_ITINERARY:
            return action.payload;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/app/reducers/itinerary.js